<template>
    <div class="w-full flex items-start gap-x-5">
        <div class="rounded-lg min-w-[30%] bg-white p-10 text-black">
            <h2 class="text-2xl font-extralight underline">Remplir les champs suivants :</h2>
            <form @submit.prevent="saveForm" class="mt-8">
                <div class="w-full flex flex-col items-start ">
                    <label for="name" class="font-light" >Nom<span class="text-[#f44545]">*</span></label>
                    <input type="text" v-model="form.name" name="name" class="h-[40px] w-full rounded-md border outline-none p-3 focus:outline-none" placeholder="John">
                </div>
                <div class="w-full flex flex-col pt-4 text-black">
                    <label for="function" class="font-light" >Fonction<span class="text-[#f44545]">*</span></label>
                    <input type="text" v-model="form.function" placeholder="" name="function" class="h-[40px] w-full rounded-md border outline-none p-3 focus:outline-none">
                </div>
                <div class="w-full flex flex-col pt-4 text-black">
                    <label for="debut" class="font-light" >Début<span class="text-[#f44545]">*</span></label>
                    <input type="date" v-model="form.debut" placeholder="" name="debut" class="h-[40px] w-full rounded-md border outline-none p-3 focus:outline-none">
                </div>
                <div class="w-full flex flex-col pt-4 text-black">
                    <label for="fin" class="font-light" >Fin<span class="text-[#f44545]">*</span></label>
                    <input type="date" v-model="form.fin" placeholder="" name="fin" class="h-[40px] w-full rounded-md border outline-none p-3 focus:outline-none">
                </div>
                <div class="w-full flex flex-col pt-4 text-black">
                    <label for="place" class="font-light" >Lieu<span class="text-[#f44545]">*</span></label>
                    <input type="text" v-model="form.place" placeholder="" name="place" class="h-[40px] w-full rounded-md border outline-none p-3 focus:outline-none">
                </div>
                <div class="w-full flex flex-col pt-4 text-black">
                    <label for="subject" class="font-light" >Sujet<span class="text-[#f44545]">*</span></label>
                    <input type="text" v-model="form.subject" placeholder="" name="subject" class="h-[40px] w-full rounded-md border outline-none p-3 focus:outline-none">
                </div>
                <div class="w-full flex flex-col pt-4 text-black">
                    <label for="transport" class="font-light" >Transport<span class="text-[#f44545]">*</span></label>
                    <input type="text" v-model="form.transportation" placeholder="" name="transport" class="h-[40px] w-full rounded-md border outline-none p-3 focus:outline-none">
                </div>
                <div class="w-full flex flex-col pt-4 text-black">
                    <label for="budget" class="font-light" >Budget<span class="text-[#f44545]">*</span></label>
                    <input type="number" min="0" v-model="form.budget" placeholder="" name="budget" class="h-[40px] w-full rounded-md border outline-none p-3 focus:outline-none">
                </div>
                <button type="submit" :disabled="asSend" class="w-full mt-8 py-3 bg-[#5357ec] text-white rounded-md">
                    <Loader2 v-if="asSend" class="animate-spin mx-auto"/>
                    <span v-if="!asSend">Enregistrer</span>
                </button>
            </form>
        </div>
        <div class="rounded-lg grow min-h-[850px] bg-white">
            <div class="mx-auto w-[89%] rounded-lg px-7 py-8 mt-10">
                <div class="w-full flex justify-center mt-14 mb-20">
                    <img src="../../../../assets/uigb-logo.png" alt="logo uigb" class="h-20 w-auto object-cover">
                </div>
                        <h2 class="text-3xl font-medium text-center text-gray-700 mt-24 mb-[70px] underline">TRAVEL AUTHORIZATION</h2>
                        <p class="text-gray-700 mt-14 font-semibold">
                            NAME: {{ form.name ?? "" }}
                        </p>
                        <p class="text-gray-700 mt-10 font-semibold">
                            FUNCTION: {{ form.function ?? "" }}
                        </p>
                        <p class="text-gray-700 mt-10 font-semibold">
                            PERIOD: {{ form.debut ?? "" }} - {{ form.fin }}
                        </p>
                        <p class="text-gray-700 mt-10 font-semibold">
                            PLACE: {{ form.place ?? "" }}
                        </p>
                        <p class="text-gray-700 mt-10 font-semibold">
                            SUBJECT: {{ form.subject ?? "" }}
                        </p>
                        <p class="text-gray-700 mt-10 font-semibold">
                            TRANSPORTATION: {{ form.transportation ?? "" }}
                        </p>
                        <p class="text-gray-700 mt-10 font-semibold">
                            BUDGET: {{ form.budget ?? "" }}
                        </p>
                        <p class="text-gray-700 mt-28 text-right mr-36">
                            DATE
                        </p>
                        <p class="text-gray-700 mt-28 font-semibold text-right mr-28">
                            SIGNATURE
                        </p>
                        

            </div>
        </div>
    </div>
</template>
<script>
import {Loader2} from "lucide-vue-next";
import API from "@/service/API";
import toast from "@/components/ui/toast";
export default {
    name: "TravelAuth",
    components: {Loader2},
    data() {
        return {
            asSend: false,
            form: {
                name: null,
                function: null,
                debut: null,
                fin: null,
                place: null,
                subject: null,
                transportation: null,
                budget: null,
            }
        };
    },
    methods: {
        clearForm() {
            this.form.name = null;
            this.form.function = null;
            this.form.debut = null;
            this.form.fin = null;
            this.form.place = null;
            this.form.subject = null;
            this.form.transportation = null;
            this.form.budget = null;
        },
        saveForm(){
            this.asSend = true;
            const data = {
                "content" : JSON.stringify(this.form),
                "doc_id":27,
                "user_id": localStorage.getItem("userId") ?? this.$store.getters.userId
            }
            API.post("user-docs", data)
                .then((response) => {
                    if(response.data["status"] == 'success'){
                        toast.success("Succès","Demande enregistré avec succès",4000)
                        this.clearForm();
                    }else{
                        toast.error("Oops..",response.data["message"],4000)
                    }
                })
                .catch(() => {
                    toast.error("Oops..","Il semble avoir une erreur, merci de réessayé.",4000)
                }).finally(()=>{
                    this.asSend = false;
                });
        }
    },
}
</script>